


























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./time_sale_setting_add.vue";
import Edit from "./time_sale_setting_edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: [];

  dispatchType: string = "stadium/timeSaleSetting";

  deleteConfirmContent = "确定要删除该设置吗？";
  dispatchTypeDelete: string = "stadium/timeSaleSettingDelete";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型", scopedSlots: { customRender: "mins" }  },
    { title: "周期", scopedSlots: { customRender: "weeks" } },
    { title: "开始时刻", scopedSlots: { customRender: "hour_from" } },
    { title: "结束时刻", scopedSlots: { customRender: "hour_to" }},
    { title: "添加时间", dataIndex: "created_time" },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
      },
      false
    );
  }
}
